import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-report_existing_sso-action_unknown';
/**
 * This is fired when we report an existing SSO account to the user when they use that email to attempt a Sign Up.
 */
export function trackSignupReportExistingSso() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
